import { render, staticRenderFns } from "./ontick-card-title.component.vue?vue&type=template&id=23ee932c"
import script from "./ontick-card-title.component.vue?vue&type=script&lang=js"
export * from "./ontick-card-title.component.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports